export { default } from '@shikijs/langs/splunk'
